module.exports = __webpack_public_path__ + "img/switch.14c1df49.gif";